export default __webpack_public_path__ + "static/media/1 - Навигация.5b2970ad.jpg";